import { createRouter, createWebHistory } from "vue-router";
import jwtDecode from "jwt-decode";
import eventBus from "../views/eventBus"; // ปรับ path ตามจริง

// Import views ของคุณทั้งหมด
import Dashboard from "../views/Dashboard.vue";
import PerformanceTrends from "../views/PerformanceTrends.vue";
import Signin from "../views/Signin.vue";
import GameList from "../views/Gamelist.vue";
import GameListProd from "../views/GamelistProd.vue";
import users from "../views/Users.vue";
import LimitReward from "../views/LimitReward.vue";
import RTP from "../views/RTP.vue";
import BetRange from "../views/BetRange.vue";
import Realtime from "../views/Realtime.vue";


// import Mayan from "../views/Mayan.vue"; // import ซ้ำ ไม่ต้องใช้

// รายเกมทั้งหมดใช้ component เดียว (generic) โดยรับ schema_name จาก route param
// รายชื่อเกมมาจาก API gameconfig (ดูใน SidenavList.vue) → ไม่ต้อง maintain ที่นี่
import GameDetail from "../views/GameDetail.vue";

const routes = [
  { path: "/", redirect: "/dashboard-default" },
  {
    path: "/dashboard-default",
    name: "Dashboard",
    component: Dashboard,
    meta: { requiresAuth: true },
  },
  {
    path: "/realtime",
    name: "realtime",
    component: Realtime,
    meta: { requiresAuth: true },
  },
  { path: "/signin", name: "Signin", component: Signin },
  { path: "/trends", name: "Performance Trends", component: PerformanceTrends, meta: { requiresAuth: true } },
  { path: "/rtp", name: "rtp", component: RTP, meta: { requiresAuth: true } },
  {
    path: "/gamelist",
    name: "gamelist",
    component: GameList,
    meta: { requiresAuth: true },
  },
  {
    path: "/gameactive",
    name: "gameactive",
    component: GameListProd,
    meta: { requiresAuth: true },
  },
  {
    path: "/user",
    name: "user",
    component: users,
    meta: { requiresAuth: true },
  },
  {
    path: "/limit-reward",
    name: "Limit Reward",
    component: LimitReward,
    meta: { requiresAuth: true },
  },
  {
    path: "/bet-range",
    name: "bet-range",
    component: BetRange,
    meta: { requiresAuth: true },
  },
    {
    path: "/game/:schema",
    name: "game-detail",
    component: GameDetail,
    props: true,
    meta: { requiresAuth: true },
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

// ฟังก์ชันตรวจ JWT หมดอายุ
function isTokenExpired(token) {
  try {
    const decoded = jwtDecode(token);
    const now = Date.now() / 1000; // วินาที
    return decoded.exp < now;
  } catch {
    return true; // ถ้า decode ไม่ได้ถือว่า expired
  }
}

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");
  const lastActivity = localStorage.getItem("lastActivity");
  const now = Date.now();
  const timeout = 60 * 60 * 1000; // 1 ชั่วโมง

  if (token) {
    if (!lastActivity) {
      // กรณีไม่มี lastActivity ให้รีเซ็ตใหม่
      localStorage.setItem("lastActivity", now.toString());
      return next();
    }

    if (now - parseInt(lastActivity) > timeout) {
      localStorage.removeItem("token");
      localStorage.removeItem("lastActivity");

      eventBus.emit("session-expired");

      return next(false);
    } else {
      localStorage.setItem("lastActivity", now.toString());
      return next();
    }
  } else if (to.meta.requiresAuth) {
    return next({
      path: "/signin",
      query: { redirect: to.fullPath },
    });
  } else {
    return next();
  }
});

export default router;
